import ContactHero from "./Hero/ContactHero";
import Form from "./Form/Form";

// fetching
import { useEffect, useState } from "react";
import useFetch from "Hooks/useFetch";
import IsLoading from "Components/RequestHandler/IsLoading";
import IsError from "Components/RequestHandler/IsError";
const Contact = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("contact");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) return <IsLoading />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <ContactHero data={data} />
        <Form />
      </main>
    );
  }
};

export default Contact;
